import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material';
import { AdalService } from './../shared/azure-authentication/adal.service';
import { Team } from '../teams/team.model';
import { TeamAddComponent } from '../teams/team-add/team-add.component';
import { User } from "../users/user.model";
import { UserAddComponent } from '../users/user-add/user-add.component';
import { UserService } from '../users/user.service';
import { ConfigurationComponent } from '../configuration/configuration.component';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
    private isAuthenticatedSubscription: any;
    isAdmin = false;
    hasTeam = false;
    persona;
    @Output() linkSelected: EventEmitter<any> = new EventEmitter();

    constructor(public dialog: MatDialog,
        private adalService: AdalService,
        private userService: UserService){
    }

    ngOnInit() {
        this.isAuthenticatedSubscription = this.userService.currentUserAuthenticated.subscribe((currentUser: User) => {
            this.isAdmin = currentUser.isAdmin;
            this.persona = currentUser.persona;
            if (currentUser.teams) {
                this.hasTeam = false;
            } else {
                this.hasTeam = true;
            }
        });
    }

    ngOnDestroy() {
        if (this.isAuthenticatedSubscription) this.isAuthenticatedSubscription.unsubscribe();
    }

    openTeamAddDialog(team: Team) {
        this.dialog.open(TeamAddComponent, {
            disableClose: true,
        });
    }

    openUserAddDialog() {
        this.dialog.open(UserAddComponent, {
            disableClose: true,
        });
    }

    openConfigurationDialog() {
        this.dialog.open(ConfigurationComponent,
            {
          disableClose: true
        });
    }

    toggleSidenav() {
        this.linkSelected.emit();
    }

    logout() {
        this.adalService.logout();
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/sidebar/sidebar.component.ts